import { render, staticRenderFns } from "./User.vue?vue&type=template&id=9dea0b04&scoped=true&lang=pug&"
import script from "./User.vue?vue&type=script&lang=js&"
export * from "./User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dea0b04",
  null
  
)

export default component.exports